import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { useUserData, useUserInfo } from '../hooks/store';
import { useIsClubPage } from '../hooks/config';
import { useImageUtils } from '../hooks';
import { PersonalizedRowV2 as Component } from '../components/PersonalizedRow';

const PersonalizedRow = forwardRef((props, ref) => {

    const {
        ssr,
        properties,
        rank,
    } = props;
    const { data: userData } = useUserData();
    const isClubPage = useIsClubPage();
    const { formatTemplateUrl } = useImageUtils();
    const { userId = '' } = userData;

    const {
        loading,
        data,
        error,
    } = useUserInfo(userId, {
        ssr,
    });

    const { title, categories } = properties;
    const favoriteTeam = data?.userInfo?.favoriteTeam;

    if (
        isClubPage
        || loading
        || error
        || typeof favoriteTeam === undefined
        || favoriteTeam?.id === -1
    ) {

        return null;

    }

    const { id: teamId, name: teamName } = favoriteTeam;
    const teamImageTemplateUrl = formatTemplateUrl(properties[`teamId-${teamId}-bgImageStoragePath`]);

    return (
        <Component
            ref={ref}
            title={title}
            teamId={teamId}
            teamName={teamName}
            teamImageTemplateUrl={teamImageTemplateUrl}
            categories={categories}
            rank={rank}
        />
    );

});

PersonalizedRow.propTypes = {
    rank: PropTypes.number.isRequired,
    ssr: PropTypes.bool,
    properties: PropTypes.object,
};

PersonalizedRow.defaultProps = {
    ssr: false,
    properties: {},
};

export default PersonalizedRow;
